module.exports = __webpack_public_path__ + "img/planIndividualColorMobile.d4e40c7d.svg";